import { useState } from "react";
import { Link } from "wouter";
import { Mail, ArrowRight, Sparkles } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { BRAND } from "@/lib/data";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HEADER_IMG =
  "https://customer-assets.emergentagent.com/job_wellness-at-home-15/artifacts/ay73xzg8_FB_IMG_1780415792482.jpg";

export default function Products() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/notify-list`, { email, list: "products" });
      setDone(true);
      toast.success("You're on the list — we'll be in touch.");
    } catch (err) {
      toast.error("Couldn't add you. Please try again or email us directly.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="page-products" className="bg-spa-cream min-h-[80vh]">
      <section className="container-spa pt-16 sm:pt-20 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-spa-sand border border-spa-border mb-8">
              <Sparkles className="w-3.5 h-3.5 text-spa-cyan" strokeWidth={1.5} />
              <span className="text-xs uppercase tracking-[0.2em] font-semibold text-spa-gray">Coming Soon</span>
            </div>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-spa-dark leading-[1.02]">
              Wellness products,<br />
              <span className="italic text-spa-green">on the way.</span>
            </h1>
            <p className="mt-8 text-lg text-spa-gray max-w-xl leading-relaxed">
              Stephanie is curating a small line of hand-selected oils, balms, and home rituals to
              take the calm of a session home with you. Leave your email and we&apos;ll quietly let you
              know the moment they&apos;re ready.
            </p>

            {!done ? (
              <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md">
                <input
                  data-testid="products-notify-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="input-spa flex-1"
                />
                <button
                  data-testid="products-notify-submit"
                  type="submit"
                  disabled={submitting}
                  className="btn-primary whitespace-nowrap"
                >
                  {submitting ? "Adding..." : <>Notify me <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></>}
                </button>
              </form>
            ) : (
              <div data-testid="products-notify-success" className="mt-10 card-spa max-w-md bg-spa-sand border-spa-cyan">
                <p className="font-serif text-xl text-spa-dark mb-1">You&apos;re on the list.</p>
                <p className="text-sm text-spa-gray">We&apos;ll send one short email when the shop opens.</p>
              </div>
            )}

            <div className="mt-12 pt-8 border-t border-spa-border flex flex-wrap gap-6 text-sm text-spa-gray">
              <span>Questions in the meantime?</span>
              <a
                data-testid="products-email-link"
                href={`mailto:${BRAND.email}?subject=Products%20inquiry`}
                className="inline-flex items-center gap-2 text-spa-green hover:text-spa-green-dark font-medium"
              >
                <Mail className="w-4 h-4" strokeWidth={1.5} /> {BRAND.email}
              </a>
            </div>

            <div className="mt-10">
              <Link href="/services" data-testid="products-back-services">
                <button className="btn-secondary">Book a session instead</button>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-2xl aspect-square shadow-xl">
              <img src={HEADER_IMG} alt="Mason Massage stones in still water" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
